import React from 'react';
import { useRecordContext } from 'react-admin';
import { dayjs } from '../../../components/ex_dayjs';
import { Box } from '@mui/material';

interface IData {
    [key: string]: any;
}

const NoteField: React.FC<IData> = (props) => {
    const { notesData } = props;
    const record = useRecordContext();

    if (!record || record.lastNotes?.length === 0) return null;

    let arr = record.lastNotes;
    if (notesData.data && notesData.recordId === record.id) {
        arr = notesData.data;
    }
    return (
        <Box>
            {arr?.map((item: any) => (
                <><b>{item.firstName}</b>{' » ' + item.note + ' ('}{dayjs.utc(item.insertedDate).fromNow() + ')'}<br /> </>
            ))}
        </Box>
    );
};
export default React.memo(NoteField);
